/* 
Social Share Links:
WhatsApp:
https://wa.me/?text=[post-title] [post-url]
Facebook:
https://www.facebook.com/sharer.php?u=[post-url]
Twitter:
https://twitter.com/share?url=[post-url]&text=[post-title]
Pinterest:
https://pinterest.com/pin/create/bookmarklet/?media=[post-img]&url=[post-url]&is_video=[is_video]&description=[post-title]
LinkedIn:
https://www.linkedin.com/shareArticle?url=[post-url]&title=[post-title]
*/
let facebookBtn = document.querySelector(".facebook-btn");
let twitterBtn = document.querySelector(".twitter-btn");
let linkedinBtn = document.querySelector(".linkedin-btn");
let whatsappBtn = document.querySelector(".whatsapp-btn");
// let pinterestBtn = document.querySelector(".pinterest-btn");

let pageTitle = document.querySelector('[data-page-title]');
// let thumbUrl = document.querySelector('[data-thumb-url]');

function initSocialShare() {
    let $shareBtnContainer = document.querySelector('.share-btn-container');
    if (!$shareBtnContainer) return;

    if (!pageTitle) {
        let $newsDetailsShare =
            $shareBtnContainer.closest('.news-details-share');

        if (!$newsDetailsShare) return;

        $newsDetailsShare.style = 'display:none;';

        return;
    }

    // let thumbData = thumbUrl.getAttribute('data-thumb-url');
    let titleData = pageTitle.getAttribute('data-page-title');

    let postUrl = encodeURI(document.location.href);
    let postTitle = encodeURI(titleData);
    // let postImg = encodeURI(thumbData);

    if (facebookBtn) {
        facebookBtn.setAttribute(
            "href", 'https://www.facebook.com/sharer.php?u=' + postUrl
        );
    }

    if (twitterBtn) {
        twitterBtn.setAttribute(
            "href",
            'https://twitter.com/share?url=' + postUrl + '&text=' + postTitle
        );
    }


    if (linkedinBtn) {
        linkedinBtn.setAttribute(
            "href",
            'https://www.linkedin.com/shareArticle?url=' + postUrl + '&title=' + postTitle
        );
    }

    if (whatsappBtn) {
        whatsappBtn.setAttribute(
            "href",
            'https://wa.me/?text=' + postTitle + ' ' + postUrl
        );
    }

    /*if (pinterestBtn) {
    pinterestBtn.setAttribute(
        "href",
        'https://pinterest.com/pin/create/bookmarklet/?media=' + postImg + '&url=' + postUrl + '&description=' + postTitle
    );}*/
}
initSocialShare();